import { useEffect, useState } from "react";
import { getEquiposBitacoraByIdNave } from "../functions/api/equiposBitacora";

function useEquiposNaves(token, idNave, reload) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getEquiposBitacoraByIdNave(token, idNave)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [idNave, reload]);

  return { data, loading, error };
}

export default useEquiposNaves;
